module.exports = __webpack_public_path__ + "static/img/Jamie-Maclaren.5fb6f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jamie-Maclaren.jpg
// module id = DoPg
// module chunks = 0